import { render, staticRenderFns } from "./quick-link.vue?vue&type=template&id=0f548d8c"
import script from "./quick-link.vue?vue&type=script&lang=js"
export * from "./quick-link.vue?vue&type=script&lang=js"
import style0 from "./quick-link.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports